import ApiService from '../../utils/fetch';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const currencyConversionUrl = `${BASE_URL}currencyconversion/overview`;

export const fetchCurrencyConversion = async () => {
    const url = `${currencyConversionUrl}`;
    const response = await ApiService.get(url);
    return response.data;
};